<template>
  <div class="home-container">
    <div class="layout-grid">
      <!-- Sidebar Navigation -->
      <div class="sidebar">
        <div class="menu-header">
          <h3>Absensi Pegawai</h3>
        </div>
        <div class="menu-list">
          <div 
            v-for="(item, index) in filteredOptions" 
            :key="index"
            class="menu-item"
            :class="{ 'active': $route.path === item.link }"
            @click="getViews(item.link)"
          >
            <span class="menu-label">{{ item.label }}</span>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="main-content">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    'deviceType': String
  },
  data() {
    return {
      roleToCheck: "ROLE_OPERATOR",
      options: [
        {value: 'all_rekapan', label: 'All Rekapan', link: '/t15M4szIx3Ux', bgColor: 'FFFFFF', role: "ROLE_OPERATOR"},
        {value: 'rekapan', label: 'Rekapan', link: '/KboDGentICHR', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'hari_ini', label: 'Hari Ini', link: '/e8YA0E9R5cdn', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'wfa_or_wfh', label: 'WFA / WFH / FWA', link: '/oIrSx1N515dP', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'januari', label: 'Januari', link: '/2xofcF5tq5Gj/GkCMz0QE329m/1', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'februari', label: 'Februari', link: '/2xofcF5tq5Gj/GkCMz0QE329m/2', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'maret', label: 'Maret', link: '/2xofcF5tq5Gj/GkCMz0QE329m/3', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'april', label: 'April', link: '/2xofcF5tq5Gj/GkCMz0QE329m/4', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'mei', label: 'Mei', link: '/2xofcF5tq5Gj/GkCMz0QE329m/5', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'juni', label: 'Juni', link: '/2xofcF5tq5Gj/GkCMz0QE329m/6', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'juli', label: 'Juli', link: '/2xofcF5tq5Gj/GkCMz0QE329m/7', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'agustus', label: 'Agustus', link: '/2xofcF5tq5Gj/GkCMz0QE329m/8', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'september', label: 'September', link: '/2xofcF5tq5Gj/GkCMz0QE329m/9', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'oktober', label: 'Oktober', link: '/2xofcF5tq5Gj/GkCMz0QE329m/10', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'november', label: 'November', link: '/2xofcF5tq5Gj/GkCMz0QE329m/11', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'desember', label: 'Desember', link: '/2xofcF5tq5Gj/GkCMz0QE329m/12', bgColor: 'FFFFFF', role: "ROLE_EMPLOYEE"},
        {value: 'jadwal_wfa_or_wfh', label: 'Jadwal WFA / WFH / FWA', link: '/l3qcI09c2Mdj', bgColor: 'FFFFFF', role: "ROLE_OPERATOR"},
        {value: 'list_all_wfa_or_wfh', label: 'List All WFA / WFH / FWA', link: '/mOcDZwljZp', bgColor: 'FFFFFF', role: "ROLE_ADMIN"}
      ]
    }
  },
  computed: {
    get_role() {
      return this.$store.state.userRoles
    },
    get_loading() {
      return this.$store.state.loading
    },
    filteredOptions() {
      return this.options.filter(item => this.isRolePresent(this.get_role, item.role))
    }
  },
  created() {
    this.$store.dispatch('get_roles')
    this.isRolePresent()
  },
  methods: {
    getViews: function(value){
      if (this.$route.path !== value) {
        this.$router.push(value);
      }
    },
    isRolePresent: function(params, value) {
      const roles = params;
      const roleToCheck = value;

      const isRolePresent = roles?.includes(roleToCheck);
      return isRolePresent;
      // console.log(isRolePresent); // This will output: true
    }
  }
}
</script>

<style scoped>
/* Container utama */
.home-container {
  background-color: #f7fafc;
  min-height: 100vh;
  padding: 20px;
}

.layout-grid {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Sidebar styling */
.sidebar {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: fit-content;
}

.menu-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  text-align: center;
}

.menu-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.menu-list {
  padding: 12px 0;
}

.menu-item {
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
}

.menu-item:hover {
  background-color: #edf2f7;
  color: #2d3748;
  transform: translateX(2px);
}

.menu-item.active {
  background-color: #e3f2fd;
  color: #1976d2;
  border-left-color: #1976d2;
}

.menu-label {
  display: block;
}

/* Main content */
.main-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 32px;
  min-height: 600px;
}

/* Responsive design */
@media (max-width: 1024px) {
  .layout-grid {
    grid-template-columns: 250px 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .home-container {
    padding: 16px;
  }
  
  .layout-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .main-content {
    padding: 20px;
  }
  
  .menu-item {
    padding: 12px 16px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .home-container {
    padding: 12px;
  }
  
  .main-content {
    padding: 16px;
  }
  
  .menu-item {
    padding: 10px 14px;
    font-size: 12px;
  }
  
  .menu-header {
    padding: 16px;
  }
  
  .menu-header h3 {
    font-size: 14px;
  }
}
</style>